import { render, staticRenderFns } from "./BaseNumberMarker.vue?vue&type=template&id=48367908"
import script from "./BaseNumberMarker.vue?vue&type=script&lang=ts"
export * from "./BaseNumberMarker.vue?vue&type=script&lang=ts"
import style0 from "./BaseNumberMarker.vue?vue&type=style&index=0&id=48367908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports